import script from "./JsonViewer.vue?vue&type=script&lang=js"
export * from "./JsonViewer.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__